import { Drawer, Toolbar, Box, useMediaQuery, Typography, Divider, Chip } from '@mui/material';
import { BASIC_TABS, FIRST_MILE_TABS, WAREHOUSE_ADMIN_TABS, WAREHOUSE_SUPERVISOR_TABS } from './GuardTabsList';
import { DrawerList } from '../components';
import { useTranslation } from 'react-i18next';
import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { USER_ROLES, USER_ROLES_TYPES, ZSHIP_ID } from 'src/constants';
import { cloneDeep, filter } from 'lodash';
import { Pending, PhoneAndroid } from '@mui/icons-material';
const drawerWidth = 260;

export default function GuardDrawer({ openDrawer, toggleDrawer }) {
    const { profile } = useSelector((state) => state.entities.profile);
    const customizations = useSelector(state => state.entities.customizations)
    const { pathname } = useLocation();
    const { t } = useTranslation()
    const downLg = useMediaQuery(theme => theme.breakpoints.down('lg'));

    const list = useMemo(() => {
        if ([USER_ROLES_TYPES.ADMIN, USER_ROLES_TYPES.SUB_ADMIN].includes(profile?.type)) {
            let tabs = cloneDeep(WAREHOUSE_ADMIN_TABS)
            if (profile?.merchant?.shippingType === "FIRST_MILE") {
                tabs?.splice(3, 0, ...FIRST_MILE_TABS)
            }
            if (USER_ROLES_TYPES.SUB_ADMIN === profile?.type) {
                tabs = tabs?.filter(el => el?.title !== "Customizations")
            }
            return tabs
        } else if (ZSHIP_ID.includes(profile?.merchant?.id)) {
            let tabs = cloneDeep(WAREHOUSE_SUPERVISOR_TABS(profile?.permissions))
            tabs?.splice(3, 0, {
                href: "/guard/pending_orders",
                icon: Pending,
                title: "Pending orders",
            })
            return tabs
        } else if ([USER_ROLES_TYPES.SUPERVISOR].includes(profile?.type)) {

            let tabs = cloneDeep(WAREHOUSE_SUPERVISOR_TABS(''))
            tabs = tabs.filter(el => !["Mobile camera", "Barcode scanner"].includes(el?.title))
            tabs?.splice(1, 0, {
                href: "/guard/scanner",
                icon: PhoneAndroid,
                title: "Mobile camera",
            })

            return tabs
        } else {
            return [...BASIC_TABS]
        }
    }, [profile])

    useEffect(() => {
        if (downLg && openDrawer) {
            toggleDrawer();
        }
    }, [pathname, downLg]);

    return (
        <Drawer
            open={openDrawer}
            onClose={toggleDrawer}
            variant={downLg ? "temporary" : "permanent"}
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
            }}
        >
            <Toolbar />
            <Box sx={{ overflowY: 'auto', overflowX: 'hidden' }}>
                <Box
                    sx={{
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        py: 2,
                    }}
                    bgcolor="main.dark"
                >
                    {!!customizations?.warehouse &&
                        <Box display="flex" flexDirection="column" sx={{ mb: 1 }}>
                            <Typography color="secondary" variant="caption">
                                {t("The customized warehouse")}
                            </Typography>
                            <Chip size="small" color='secondary' label={customizations?.warehouse?.name} />
                        </Box>
                    }
                    <Typography color="text.white" variant="subtitle1">
                        {t("Welcome")}
                    </Typography>
                    <Typography color="text.white" variant="h1" sx={{ textAlign: 'center' }}>
                        {profile?.name}
                    </Typography>
                </Box>
                <Divider />
                <DrawerList tabs={list} />
            </Box>
        </Drawer>
    )
}